// src/pages/driverReports/carSheets/CarExpenses/recalcSummaries.js

export function recalcSummaries(incomeRows, expenseRows) {
  // 1. Filter data rows
  const incomeData = incomeRows.filter((r) => r.rowType === "data");
  const expenseData = expenseRows.filter((r) => !r.isSummary);

  // 2. Calculate Cash Received/Paid from expenses (NOT from income summary)
  const cashReceivedPaidRow = expenseRows.find(r => 
    r.label === "CASH RECEIVED / PAID TO DRIVER"
  );
  const cashReceivedPaid = cashReceivedPaidRow ? Number(cashReceivedPaidRow.total) || 0 : 0;

  // 3. Calculate POS total from income rows
  const posTotal = incomeData
    .filter((r) => (r.company || "").toUpperCase().includes("POS"))
    .reduce((acc, r) => acc + (Number(r.total) || 0), 0);

  // 4. Calculate Bank Income (all data rows)
  const totalBankIncome = incomeData.reduce(
    (sum, r) => sum + (Number(r.total) || 0),
    0
  );

  // 5. Calculate Total Expenses
  const totalExpenses = expenseData.reduce(
    (sum, r) => sum + (Number(r.total) || 0),
    0
  );

  // 6. Calculate Balance (Income - Expenses) ⭐ CORRECT!
  const balance = totalBankIncome - totalExpenses;

  // 7. Calculate Balance Payable (Balance - Cash Received/Paid)
  const balancePayable = balance;

  console.log("🧮 recalcSummaries CALCULATIONS:");
  console.log("  Bank Income:", totalBankIncome);
  console.log("  Expenses:", totalExpenses);
  console.log("  Balance (Income - Expenses):", balance);
  console.log("  Cash Received/Paid:", cashReceivedPaid);
  console.log("  Balance Payable:", balancePayable);
  console.log("  POS Total:", posTotal);

  // 8. Remove old summaries
  const newIncomeRows = incomeRows.filter((r) => r.rowType !== "summary");

  // 9. Add updated summary rows (matching finalizeSheetTotals format)
  newIncomeRows.push(
    { 
      id: "totalIncome", 
      rowType: "summary", 
      label: "TOTAL INCOME OF THE MONTH", 
      total: totalBankIncome 
    },
    { 
  id: "balance", 
  rowType: "summary", 
  label: "BALANCE (Income – Expenses)", 
  total: balance 
},
    
    { 
      id: "balancePayable", 
      rowType: "summary", 
      label: "BALANCE PAYABLE / RECEIVABLE", 
      total: balancePayable 
    }
  );

  // 10. Update expenses summary row
  const newExpenseRows = [...expenseRows];
  const summaryRowIndex = newExpenseRows.findIndex((r) => r.isSummary);
  if (summaryRowIndex !== -1) {
    newExpenseRows[summaryRowIndex] = {
      ...newExpenseRows[summaryRowIndex],
      total: totalExpenses,
    };
  }

  return {
    incomeRows: newIncomeRows,
    expenseRows: newExpenseRows,
    totalIncome: totalBankIncome,
    totalExpenses,
    balance,
    balancePayable,
    cashReceivedPaid,
    posTotal,
  };
}